import { useLanguage } from '../../contexts/language';

import { Mascot } from '../mascot';

import styles from './style.module.css';

// The landing page's picture: the mascot, large and breathing, on a soft
// disc, with three of the app's cards scattered around it. Their content is
// a fictional week, not anybody's record, and the whole picture is hidden
// from screen readers: the page's text already says everything it shows.
//
// The positions are the blueprint's, checked in a render at 390 and 1280px:
// at the top of the breath the mascot stays clear of every card.
const days = [
  { date: 12, state: 'complete' },
  { date: 13, state: 'complete' },
  { date: 14, state: 'partial' },
  { date: 15, state: 'empty' },
  { date: 16, state: 'future' },
  { date: 17, state: 'future' },
  { date: 18, state: 'future' }
];

export function HeroPicture() {
  const { text } = useLanguage();

  return (
    <div className={ styles.picture } aria-hidden='true'>
      <span className={ styles.disc }></span>

      <span className={ `${ styles.mascot } ${ styles.phone }` }>
        <Mascot size={ 204 } breathe={ true }/>
      </span>

      <span className={ `${ styles.mascot } ${ styles.desktop }` }>
        <Mascot size={ 290 } breathe={ true }/>
      </span>

      <div className={ `${ styles.card } ${ styles.week }` }>
        <span className={ styles.kicker }>{ text.landing.thisWeek }</span>

        <span className={ styles.days }>
          { days.map(function({ date, state }, index) {
            return (
              <span key={ date } className={ `${ styles.day } ${ styles[ state ] }` }>
                <span className={ styles.dayName }>{ text.landing.week[ index ] }</span>
                { date }
              </span>
            );
          }) }
        </span>
      </div>

      <div className={ `${ styles.card } ${ styles.appointment }` }>
        <span className={ styles.kicker }>{ text.landing.nextAppointment }</span>
        <span className={ styles.when }>{ text.landing.appointmentWhen }</span>
        <span className={ styles.how }>{ text.landing.appointmentHow }</span>
      </div>

      <div className={ `${ styles.card } ${ styles.note }` }>
        <span className={ styles.dot }></span>
        { text.landing.newNote }
      </div>
    </div>
  );
}
